/* STRUKT ANIMATIONS v5 */
console.log('[STRUKT] v5 loaded');

function strukktInit() {
  if (typeof gsap === 'undefined') { setTimeout(strukktInit, 100); return; }
  if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);

  var FROM = { opacity: 0, y: 44 };

  function reveal(el, delay) {
    gsap.fromTo(el, FROM, {
      opacity: 1, y: 0, duration: 0.9, ease: 'power3.out',
      delay: delay || 0, overwrite: 'auto',
      scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' }
    });
  }

  // 1. HERO timeline
  var heroLeft = document.querySelector('.lz-hero__left');
  if (heroLeft) {
    var tl = gsap.timeline({ defaults: { ease: 'power3.out', overwrite: 'auto' } });
    var ey  = heroLeft.querySelector('.lz-eyebrow');
    var h1  = heroLeft.querySelector('.lz-h1');
    var ld  = heroLeft.querySelector('.lz-lede');
    var cta = heroLeft.querySelector('.lz-cta-row');
    var st  = heroLeft.querySelector('.lz-hero__stats');
    var hr  = document.querySelector('.lz-hero__right');
    if (ey)  { gsap.set(ey,  {opacity:0,y:40}); tl.to(ey,  {opacity:1,y:0,duration:0.8}, 0.05); }
    if (h1)  { gsap.set(h1,  {opacity:0,y:40}); tl.to(h1,  {opacity:1,y:0,duration:0.9}, 0.22); }
    if (ld)  { gsap.set(ld,  {opacity:0,y:30}); tl.to(ld,  {opacity:1,y:0,duration:0.8}, 0.48); }
    if (cta) { gsap.set(cta, {opacity:0,y:24}); tl.to(cta, {opacity:1,y:0,duration:0.8}, 0.66); }
    if (st) {
      var statItems = Array.from(st.children);
      if (statItems.length) {
        gsap.set(statItems, {opacity:0, y:20});
        statItems.forEach(function(item, i) {
          tl.to(item, {opacity:1, y:0, duration:0.7}, 0.84 + i * 0.15);
        });
      }
    }
    if (hr)  { gsap.set(hr,  {opacity:0,y:50}); tl.to(hr,  {opacity:1,y:0,duration:1.0}, 0.30); }
  }

  // 2. [data-stagger] groups
  document.querySelectorAll('[data-stagger]').forEach(function(parent) {
    var kids = Array.from(parent.children);
    if (!kids.length) return;
    gsap.fromTo(kids, FROM, {
      opacity: 1, y: 0, duration: 0.85, ease: 'power3.out',
      stagger: 0.12, overwrite: 'auto',
      scrollTrigger: { trigger: parent, start: 'top 88%', toggleActions: 'play none none none' }
    });
  });

  // 3. .lz-bento cards explicit stagger
  document.querySelectorAll('.lz-bento').forEach(function(bento) {
    var cards = Array.from(bento.querySelectorAll('.lz-card'));
    if (!cards.length) return;
    gsap.fromTo(cards, { opacity: 0, y: 50 }, {
      opacity: 1, y: 0, duration: 0.85, ease: 'power3.out',
      stagger: 0.13, overwrite: 'auto',
      scrollTrigger: { trigger: bento, start: 'top 85%', toggleActions: 'play none none none' }
    });
  });

  // 4. Individual .lz-fade-up (excluding stagger children, bento, hero)
  document.querySelectorAll(
    '.lz-fade-up:not([data-stagger] *):not(.lz-bento *):not(.lz-hero *),' +
    '.lz-text-reveal:not([data-stagger] *):not(.lz-bento *):not(.lz-hero *)'
  ).forEach(function(el) {
    var delay = parseFloat(el.getAttribute('data-delay')) || 0;
    reveal(el, delay);
  });

  // 5. Section titles not in groups
  document.querySelectorAll(
    '.lz-section .lz-h2:not([data-stagger] *):not(.lz-bento *),' +
    '.lz-section .lz-h1:not([data-stagger] *):not(.lz-bento *):not(.lz-hero *)'
  ).forEach(function(el) { reveal(el, 0); });

  // 6. Product images clip-path reveal
  document.querySelectorAll('.lz-prod-ph:not([data-stagger] *):not(.lz-bento *)').forEach(function(el) {
    gsap.fromTo(el,
      { clipPath: 'inset(0 100% 0 0)' },
      { clipPath: 'inset(0 0% 0 0)', duration: 1.0, ease: 'power3.out', overwrite: 'auto',
        scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' } }
    );
  });

  // 7. Collection page — Dawn product cards grid
  var cardWrappers = Array.from(document.querySelectorAll('.card-wrapper'));
  if (cardWrappers.length) {
    var gridParent = cardWrappers[0].closest('ul, .collection__grid, section') || cardWrappers[0];
    gsap.fromTo(cardWrappers, { opacity: 0, y: 40 }, {
      opacity: 1, y: 0, duration: 0.75, ease: 'power3.out',
      stagger: 0.09, overwrite: 'auto',
      scrollTrigger: { trigger: gridParent, start: 'top 90%', toggleActions: 'play none none none' }
    });
    document.querySelectorAll('.banner__heading, .collection-hero__title').forEach(function(el) {
      reveal(el, 0);
    });
    document.querySelectorAll('.banner__subheading, .collection-hero__description').forEach(function(el) {
      reveal(el, 0.1);
    });
  }

  // 8. Product page — Dawn main-product (no scroll trigger — already in viewport on load)
  var prodMedia = document.querySelector('.product__media-wrapper');
  var prodInfo  = document.querySelector('.product__info-wrapper');
  if (prodMedia || prodInfo) {
    if (prodMedia) {
      // IMPORTANT: no transform (x/y) on this element — .product__media-wrapper is the
      // direct parent of the sticky media-gallery (.product__column-sticky). A CSS
      // transform on an ancestor creates a new containing block and silently breaks
      // position: sticky on the child, for the entire page (not just during the
      // animation). Opacity-only fade avoids this entirely.
      gsap.fromTo(prodMedia, { opacity: 0 }, {
        opacity: 1, duration: 1.0, ease: 'power3.out', overwrite: 'auto', delay: 0.15, clearProps: 'transform'
      });
    }
    if (prodInfo) {
      var nodes = [
        prodInfo.querySelector('.product__title'),
        prodInfo.querySelector('.price__container, .price'),
        prodInfo.querySelector('.product-form__buttons, .product-form'),
        prodInfo.querySelector('.product__description, .product__description-content')
      ].filter(Boolean);
      gsap.fromTo(nodes, { opacity: 0, y: 30 }, {
        opacity: 1, y: 0, duration: 0.8, ease: 'power3.out',
        stagger: 0.12, overwrite: 'auto', delay: 0.25
      });
    }
    // Related products grid
    var relCards = Array.from(document.querySelectorAll('.related-products .card-wrapper'));
    if (relCards.length) {
      gsap.fromTo(relCards, { opacity: 0, y: 40 }, {
        opacity: 1, y: 0, duration: 0.75, ease: 'power3.out',
        stagger: 0.1, overwrite: 'auto',
        scrollTrigger: { trigger: relCards[0], start: 'top 90%', toggleActions: 'play none none none' }
      });
    }
  }

  window.addEventListener('load', function() {
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', strukktInit);
} else {
  strukktInit();
}

/* ── Compteur animé pour les statistiques du hero ── */
(function () {
  'use strict';

  function animateStat(el) {
    var raw = el.textContent;
    var match = raw.match(/\d+/);
    if (!match || Number(match[0]) < 10 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }
    var target = Number(match[0]);
    var prefix = raw.slice(0, match.index);
    var suffix = raw.slice(match.index + match[0].length);
    var duration = 1200;
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(target * eased);
      el.textContent = prefix + current + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = raw;
      }
    }
    requestAnimationFrame(step);
  }

  var stats = document.querySelectorAll('.lz-hero__stats dd');
  if (!stats.length) return;

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateStat(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    stats.forEach(function (el) { obs.observe(el); });
  }
})();


